import { Component, OnInit, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';

@Component({
  selector: 'app-terminos',
  standalone: true,
  templateUrl: './terminos.component.html',
})
export class TerminosComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.setMetaTags({
      title: 'Términos y condiciones — Chambia',
      description: 'Consulta los términos y condiciones de uso de la plataforma Chambia.',
      path: '/terminos',
    });
  }
}
